




























import { getJourneyReportTitle, JourneyReportsTypes, JourneyReportsChartTitle } from '../../core/utils/type-journeys';
import Loading from 'vue-loading-overlay';
import { Component, Prop, Vue, Emit, Mixins } from 'vue-property-decorator';
import { JourneyReportsDict, JourneyStateReport, JourneyStateReportPoint } from '../models/JourneyInfo';
import exportingInit from 'highcharts/modules/exporting';
import { ColorsList, getColorByState, getMilisecondsFromTimestamp, getStateByNumber, getUniqueDaysFromTimestampListParsed, isEmptyObject, TypeVehicleState } from '../../core/utils';
import Highcharts from 'highcharts';
import { Chart } from 'highcharts-vue';
import Xrange from 'highcharts/modules/xrange';
Xrange(Highcharts);

import { JourneyStateChartPoint } from '../models/JourneysReports';
exportingInit(Highcharts);
@Component({
    components: { 
        Loading,
        highcharts: Chart,
    }
})
export default class JourneyReports extends Vue {
    @Prop({default: {}}) journeyReports: JourneyReportsDict;
    @Prop({default: {}}) journeySummary: object;
    activeTab: number = 0;
    tabsContent: object = {
        [JourneyReportsTypes.state_report]: {
          options: {},
          has_data: true
        }
    }
    showCharts: boolean = false;
    noReportDataText: string = 'Este reporte no tiene datos';
    stateReportTickInterval: number = 900000 // 15 minutes in milliseconds
    chartReference:any = null;


    mounted(){
      this.setOptionsForStateChart();
    }

    setOptionsForStateChart(){
      if(this.stateReportHasData()){
        this.tabsContent[JourneyReportsTypes.state_report]['options'] = this.getReportStateChart();
        this.setLegendColors();

        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));  
        }, 500);
      }else{
        this.stateReportHasntData();
      }
    }

    setLegendColors(){
      (function(H:any) {
      H.Legend.prototype.getAllItems = function () {
                let allItems = [];
                H.each(this.chart.series, function (series) {
                    let seriesOptions = series && series.options;
                    if (series && series.type === 'xrange') {
                        series.color = series.userOptions.color
                    }
                    // Handle showInLegend. If the series is linked to another series,
                    // defaults to false.
                    if (series && H.pick(
                        seriesOptions.showInLegend,
                        !H.defined(seriesOptions.linkedTo) ? undefined : false, true
                    )) {

                        // Use points or series for the legend item depending on
                        // legendType
                        allItems = allItems.concat(
                            series.legendItems ||
                            (
                                seriesOptions.legendType === 'point' ?
                                    series.data :
                                    series
                            )
                        );
                    }
                });

                H.fireEvent(this, 'afterGetAllItems', { allItems: allItems });

                return allItems;
            }
    })(Highcharts)
    }

    stateReportHasData(){
      if(this.journeyReports[JourneyReportsTypes.state_report]['data'] == null){
          return false
      }else{
        return true
      }
    }

    stateReportHasntData(){
      this.tabsContent[JourneyReportsTypes.state_report]['has_data'] = false 
    }

    getReportStateSeries(){
      let chartSeries: Array<object> = [];
      if(!this.stateReportHasData()){
        this.stateReportHasntData();
        return {}
      }
        
        let stateReportData:JourneyStateReport = this.journeyReports[JourneyReportsTypes.state_report];
        let dataPoints:Array<JourneyStateReportPoint> = Object.keys(stateReportData.data).length ? Object.values(stateReportData.data).flat(1) : []
        let points:Array<JourneyStateReportPoint> = dataPoints;
        if(points.length == 0){
          this.stateReportHasntData();
        }
        let self = this;

        interface stateValues {
          state_value: number,
          state_name: string
        }
        //recorro la lista de puntos y me quedo con los estados unicos (valor y nombre)
        let uniqueStatesNames:Array<stateValues> = points.length ? points.map(function(point){
          return {
            state_value: point.state,
            state_name: getStateByNumber(point.state, '', false)
          }
        }).reduce((acc:Array<stateValues>, current:stateValues) => {
          //elimino los estados duplicados filtrando por nombre
          const x = acc.find(item => item.state_name === current.state_name);
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, []): [];
        
        chartSeries = uniqueStatesNames.length  == 0 ? [] : uniqueStatesNames.map(function(state: stateValues){
          return {
            name: state.state_name,
            color: getColorByState(state.state_value),
            data: self.getPointsFormatted(self.getFilteredPointsByState(state.state_value, points)) //todos los puntos correspondientes al estado
          }
        })
        return chartSeries  
    }

    getFilteredPointsByState(state_number:number, points: Array<JourneyStateReportPoint>): Array<JourneyStateReportPoint>{
      return points.filter(point => point.state == state_number)
    }

    getPointsFormatted(points: Array<JourneyStateReportPoint>): Array<JourneyStateChartPoint>{
      let parsedPoints = points.length == 0 ? [] : points.map(function(point: JourneyStateReportPoint){
        return {
          color: getColorByState(point.state),
          x:  getMilisecondsFromTimestamp(point.datetime_from),
          x2: getMilisecondsFromTimestamp(point.datetime_to),
          y: point.vehicle_index
        }
      })
      return parsedPoints
    }

    getVehiclesForReportState():Array<string>{
      let stateReportData:JourneyStateReport = this.journeyReports[JourneyReportsTypes.state_report];
      let vehiclePlates =  stateReportData && Object.keys(stateReportData.data).length ? Object.keys(stateReportData.data).map(function(vehicleId:string){
        if(stateReportData.data[vehicleId].length > 0){
          return stateReportData.data[vehicleId][0].vehicle_plate
        }else{
          return vehicleId
        }
      }) : [];
      return vehiclePlates
     }


    getReportStateChart(){
      let self = this;
        let journeyStartDate = this.journeySummary['datetime_from'];
        let journeyEndDate = this.journeySummary['datetime_to'];
        let minJourneyValueInMs = getMilisecondsFromTimestamp(journeyStartDate);
        let maxJourneyValueInMs = journeyEndDate !== null ? getMilisecondsFromTimestamp(journeyEndDate) : null;

        return {
          chart: {
              type: 'xrange',
              zoomType: 'x',
              height: 400
          },
          plotOptions: {
            series: {
              grouping: false
            }
          },
          legend: {
            enabled: true,
            verticalAlign: 'top',
          },
          title: {
              text: JourneyReportsChartTitle.state_report
          },
          xAxis: {
            zoomEnabled: true,
            type: 'datetime',
            tickInterval: self.stateReportTickInterval, //intervalos 30 minutos
            // rango de fecha de la jornada
            min: minJourneyValueInMs,
            max: maxJourneyValueInMs,
            events: {
              // setExtremes: function (event) {
              //   let chart = this.chart;
              //   let xAxis = chart.xAxis[0];
              //   if (event && !event.min && !event.max) {
              //      xAxis.options.tickInterval = self.stateReportTickInterval; //30minutes
              //       xAxis.chart.redraw();
              //   }else{
              //       xAxis.options.tickInterval = 900000; //15 minutes
              //       xAxis.chart.redraw();
              //   }
              // }
            },
            endOnTick: true,
            tickPositioner: function(min, max) {
              // let interval = this.options.tickInterval || (1800000); // default 30 minutes
              // let ticks:number[] = [];
              // for (var i = min; i <= max; i += interval) {
              //   ticks.push(i);
              // }
              // ticks[ticks.length - 1] = max;
              // return ticks;
            },
            labels: {
              formatter: function(){
                if (this.isFirst || this.isLast) {
                  return Highcharts.dateFormat('%d/%m - %H:%M', this.value)
                } else {
                 return Highcharts.dateFormat('%H:%M', this.value);
                }
              }
            }
          },
          yAxis: {
              title: {
                  text: ''
              },
              categories: self.getVehiclesForReportState(),
              reversed: true,
              
          },
          series: self.getReportStateSeries()

      }
    }

    reportHasData(reportKey: string){
      return this.journeyReports[reportKey] && this.journeyReports[reportKey] && this.journeyReports[reportKey]['data'].length > 0 ? true : false
    }

    getCountByState(points, state) {
      return points.filter(d => d.state === state).length;
    }

    getChartOptions(reportKey: string){
        return this.tabsContent[reportKey];
    }

    matchKeyInJourneyReports(reportKey: string){
        return JourneyReportsTypes[reportKey]
    }

    getReportTitle(reportKey: string){
        return getJourneyReportTitle(reportKey)
    }
    
}
